export enum IconTypes {
  Default,
  Preview,
  Button,
}
